import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/core/services/data.service';
import { PosService } from 'src/app/core/services/pos.service';

@Component({
  selector: 'dq-utility-bar',
  templateUrl: './utility-bar.component.html',
  styleUrls: ['./utility-bar.component.scss'],
})
export class UtilityBarComponent implements OnInit {
  classBtn1: string = '';
  img1: string = '';
  classBtn2: string = '';
  img2: string = '';

  constructor(
    private posService: PosService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.dataService.getMapUp$().subscribe((mapUp) => {
      if (mapUp) {
        this.classBtn1 = 'btn-visualizacion';
        this.classBtn2 = 'btn-light';
        this.img1 = 'icon-top-active.svg';
        this.img2 = 'icon-bottom-disable.svg';
      } else {
        this.classBtn1 = 'btn-light';
        this.classBtn2 = 'btn-visualizacion';
        this.img1 = 'icon-top-disable.svg';
        this.img2 = 'icon-bottom-active.svg';
      }
    });
  }

  applyFilterGlobal($event: any) {
    this.posService.filterPos(($event.target as HTMLInputElement).value);
  }

  changeMapPosition() {
    this.dataService.sendChangeMapPosition();
  }
}
